<div class="auth-page">
	<div class="form-block">
		<app-verification></app-verification>
	</div>
</div>
